define('shared/initializer/form/adapters/mixins/ThrobberOnBeforeSubmit',[
    'shared/lib/RSVP'
], function ( 
    RSVP 
) {
    'use strict';

    function Ctor() { 
    }

    Ctor.prototype.doBeforeSubmit = function( ) {
        var me = this;
        return me.block();
    };

    Ctor.prototype.doSubmitFail = function(reason) {
        var me = this;
        return RSVP.resolve(me.resume())
            .then(function(){
                return reason;
            });
    };

    return Ctor;
});
